import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getMABExperimentIsMasterLive, getMABExperimentVariantsSize
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
// @ts-expect-error Untyped module
import { startMABExperiment } from '../redux/actions/mabExperimentActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getLangKey(key, isLive) {
  const prefix = isLive ? 'alreadyPublished' : 'allDrafts';
  return `pageSettings.mabPublishConfirmModal.${prefix}.${key}`;
}
const MABPublishConfirmModal = ({
  dismissCallback
}) => {
  const mabExperimentIsPrimaryLive = useSelector(getMABExperimentIsMasterLive);
  const numberOfVariants = useSelector(getMABExperimentVariantsSize);
  const dispatch = useDispatch();
  const publishMAB = useCallback(() => {
    dispatch(startMABExperiment());
    dismissCallback();
  }, [dismissCallback, dispatch]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "info",
    width: 540,
    centered: true,
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: -36,
      offsetTop: 84,
      children: /*#__PURE__*/_jsx(Illustration, {
        alt: I18n.text(getLangKey('illustration', mabExperimentIsPrimaryLive)),
        name: "automated-testing",
        width: 125
      })
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: dismissCallback
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('header', mabExperimentIsPrimaryLive)
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('body', mabExperimentIsPrimaryLive),
        options: {
          count: mabExperimentIsPrimaryLive ? numberOfVariants - 1 : numberOfVariants
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "center",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: publishMAB,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('confirmLabel', mabExperimentIsPrimaryLive)
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: dismissCallback,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('dismissLabel', mabExperimentIsPrimaryLive)
        })
      })]
    })]
  });
};
export default MABPublishConfirmModal;